import { render, staticRenderFns } from "./ModalProductPriceCategory.vue?vue&type=template&id=57209f11&"
import script from "./ModalProductPriceCategory.vue?vue&type=script&lang=js&"
export * from "./ModalProductPriceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports